import { Action } from '@ngrx/store';

export const SET_IMPERSONATED_USER = '[User] Set Impersonated User';
export const CLEAR_IMPERSONATED_USER = '[User] Clear Impersonated User';

export class SetImpersonatedUser implements Action {
  readonly type = SET_IMPERSONATED_USER;
  constructor(public payload: { userId: string }) {}
}

export class ClearImpersonatedUser implements Action {
  readonly type = CLEAR_IMPERSONATED_USER;
}

export type UserActions = SetImpersonatedUser | ClearImpersonatedUser;



// WEBPACK FOOTER //
// ./src/app/store/actions/user.actions.ts